import {
  GUARANTEE_DECISION__GUARANTEE,
  GUARANTEE_DECISION__GUARANTEE_AND_PARTICIPATION,
  GUARANTEE_DECISION__NO_APPROVAL,
  GUARANTEE_DECISION__PARTICIPATION
} from "./formFields";

// eslint-disable-next-line import/prefer-default-export
export const confirmationOnGuaranteeOptions = [
  {
    label: "Bürgschaft",
    value: GUARANTEE_DECISION__GUARANTEE
  },
  {
    label: "Beteiligung",
    value: GUARANTEE_DECISION__PARTICIPATION
  },
  {
    label: "Bürgschaft und Beteiligung",
    value: GUARANTEE_DECISION__GUARANTEE_AND_PARTICIPATION
  },
  {
    label: "Keine Bewilligung",
    value: GUARANTEE_DECISION__NO_APPROVAL
  }
];
